__turbopack_context__.v({
  "root": "vyDEQa_root",
});
